import Vue from 'vue';
const initialFilter = {
  PhoneId: null,
  CityId: null,
  fromDate: null,
  toDate: null,
  Pilot: null,
};
export default {
  data() {
    return {
      searchTitle: '',
      tableHeaders: [
        {
          text: 'ردیف',
          value: 'rowNumber',
        },
        {
          text: 'تاریخ شروع',
          value: 'startDate',
        },
        {
          text: 'کد گوشی',
          value: 'phoneCode',
        },
        {
          text: 'عملیات',
          value: 'action',
        },
      ],
      hasSearch: false,
      filterData: initialFilter,
      isFilterModalOpen: false,
      pagination: {
        pageNumber: 1,
        pageSize: 10,
        totalItems: 0,
      },
    };
  },
  computed: {
    hasSearch: function () {
      return Object(this.filterData)
        ?.values()
        ?.some((value) => !!value);
    },
  },
  mounted() {
    this.mounteLoding();
  },
  methods: {
    mounte: function () {
      this.onGettingList();
      this.getAllCitys();
      this.getAllPhones();
    },
    transformWorkStartList: function (workStartList) {
      return [...workStartList]?.map((item, index) => ({
        id: item?.id,
        rowNumber: index + 1,
        startDate: item?.startDate
          ? Vue.moment(item.startDate).format(' HH:mm:ss jYYYY/jMM/jDD')
          : '-',
        phoneCode: item?.phone?.code,
      }));
    },
    openFilterModal: function () {
      this.isFilterModalOpen = true;
    },
    closeFilterModal: function () {
      this.isFilterModalOpen = false;
    },
    setPagination: function (data) {
      this.pagination.pageNumber = data?.pagination?.pageNumber;
    },
    resetPageNumber: function () {
      this.pagination.pageNumber = 1;
    },
    onGettingList: function () {
      const params = {
        ...this.filterData,
        ...this.pagination,
      };
      this.getPhoneActivityWorkStartList(params);
    },
    setFilter: function (filterData) {
      this.resetPageNumber();
      this.filterData = filterData;
      this.onGettingList();
      this.closeFilterModal();
    },
    clearFilter: function () {
      this.filterData = initialFilter;
    },
  },
};
